import { createFileRoute } from "@tanstack/react-router"
import { useState } from "react"
import { authClient } from "../lib/auth-client"
import { useProduct, useTenant } from "../lib/tenant"
import { ForgotPasswordView } from "./-forgot-password/ForgotPasswordView"

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage(): React.JSX.Element {
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const branding = useTenant().branding
  const product = useProduct()

  const handleSubmit = async (email: string): Promise<void> => {
    setLoading(true)
    try {
      // The reset email + tenant-correct link are built server-side
      // (auth.ts sendResetPassword); redirectTo is a harmless fallback.
      await authClient.requestPasswordReset({
        email,
        redirectTo: `${window.location.origin}/reset-password`,
      })
    } catch {
      // Stay generic — never reveal whether the email exists.
    } finally {
      // Always show the same confirmation regardless of outcome.
      setSubmitted(true)
      setLoading(false)
    }
  }

  return (
    <ForgotPasswordView
      logo={branding?.logo}
      appName={branding?.name}
      product={product}
      loginBackground={branding?.loginBackground}
      loading={loading}
      submitted={submitted}
      onSubmit={handleSubmit}
    />
  )
}
